import PropTypes from 'prop-types';
import classNames from 'classnames';
import * as color from '../../sass/color.scss';

function SidePanelSection({
  className = '',
  style = {},
  title = null,
  subtitle = null,
  titleStyle = {},
  subtitleStyle = {},
  required = false,
  children,
}) {
  const titleHtml = title && (
    <div
      className="title"
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 4,
        // add margin when there is no subtitle
        marginBottom: subtitle
          ? 0
          : 16,
        fontSize: 14,
        fontWeight: 'bold',
        ...titleStyle,
      }}
    >
      {title}

      {required && (
        <div
          className="required"
          style={{
            width: 4,
            height: 4,
            backgroundColor: color.red,
            borderRadius: 2,
          }}
        />
      )}
    </div>
  );

  const subtitleHtml = subtitle && (
    <div
      className="subtitle"
      style={{
        fontSize: 12,
        color: color.gray500,
        ...subtitleStyle,
      }}
    >
      {subtitle}
    </div>
  );

  return (
    <div
      className={classNames('SidePanelSection', className)}
      style={{
        marginBottom: 16,
        ...style,
      }}
    >
      {title && subtitle ? (
        // wrap title & subtitle in container
        <div
          className="title-container"
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: 4,
            marginBottom: 16,
          }}
        >
          {titleHtml}
          {subtitleHtml}
        </div>
      ) : titleHtml}

      {children}
    </div>
  );
}

SidePanelSection.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  title: PropTypes.string,
  titleStyle: PropTypes.object,
  required: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

export default SidePanelSection;
